import * as yup from 'yup';

export const interests = ['brico-jardin', 'ci-culture', 'ci-deco-maison', 'tout-pour-mes-enfants', 'ci-hightech-electronique', 'ci-meubles', 'mode-et-bien-etre', 'sport'] as const;

export type Interest = (typeof interests)[number];

export type Interests = Interest[];

export const interestListResult = yup.object({ interests: yup.array(yup.string().oneOf(interests).required()) });

export type InterestListResult = yup.InferType<typeof interestListResult>;
